import { render, staticRenderFns } from "./jointOrderADetail.vue?vue&type=template&id=0b9ed9f0&scoped=true&"
import script from "./jointOrderADetail.vue?vue&type=script&lang=js&"
export * from "./jointOrderADetail.vue?vue&type=script&lang=js&"
import style0 from "./jointOrderADetail.vue?vue&type=style&index=0&id=0b9ed9f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9ed9f0",
  null
  
)

export default component.exports